/* eslint-disable import/no-anonymous-default-export */
export default {
  baseurl: "https://api.dg.dev-iuh.xyz/api/",
  baseurlFront: "https://consultify.dev-bt.xyz/",
  DocumentUrl: "https://consultify.netwave-tech.com/api//",
};
export const baseurl = "https://dgapi.dev-nuh.xyz/api/";
